import { EVENT_READY, EVENT_UPDATE_VIEW } from '../../constants/event';

class ComponentBase {
  protected elementRef: WeakRef<HTMLElement>;

  protected isDestroyed = false;
  protected onReadyBinding: (() => void) | null = null;
  protected onUpdateViewBinding: (() => void) | null = null;

  constructor(element: HTMLElement) {
    if (!element) {
      throw new Error('Element is required');
    }

    this.elementRef = new WeakRef(element);
    this.onReadyBinding = this.onReady.bind(this);
    this.onUpdateViewBinding = this.onUpdateView.bind(this);
    document.addEventListener(EVENT_READY, this.onReadyBinding, { once: true });
    document.addEventListener(EVENT_UPDATE_VIEW, this.onUpdateViewBinding);
  }

  public get element(): HTMLElement {
    const element = this.elementRef.deref();
    if (!element) {
      throw new Error('Element has been garbage collected');
    }

    return element;
  }

  protected onUpdateView(): void {
    if (!this.element?.isConnected) {
      this.destroy();
    }
  }

  protected init(): void {}

  protected destroy() {
    if (this.isDestroyed) {
      return;
    }

    this.isDestroyed = true;
    this.destroyEventListeners();
    this.onDestroy();
  }

  protected onDestroy(): void {}

  protected destroyEventListeners(): void {
    if (this.onUpdateViewBinding) {
      document.removeEventListener(EVENT_UPDATE_VIEW, this.onUpdateViewBinding);
    }
  }

  protected onReady(): void {}
}

export default ComponentBase;
